var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-text-field',{attrs:{"label":"NSU"},model:{value:(_vm.nsu),callback:function ($$v) {_vm.nsu=$$v},expression:"nsu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }